import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import { includes, map, filter } from 'lodash';
import { TagSelect } from './styled';

const { CheckableTag } = Tag;

const SelectableTag = ({ dataSource = [], onChange, selectedTags = [] }) => {
  const handleOnChange = useCallback((tag, checked) => {
    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : filter(selectedTags, (t) => t !== tag);
    onChange?.(nextSelectedTags);
  });

  return (
    <TagSelect>
      {dataSource &&
        map(dataSource, (tag) => (
          <CheckableTag
            key={tag.id}
            checked={includes(selectedTags, tag.id)}
            onChange={(checked) => handleOnChange(tag.id, checked)}>
            {tag.name}
          </CheckableTag>
        ))}
    </TagSelect>
  );
};

SelectableTag.propTypes = {
  dataSource: PropTypes.array,
  onChange: PropTypes.func,
  selectedTags: PropTypes.array
};

export default SelectableTag;
